import * as yup from 'yup';
import { SuggestionSchema, ScaleRatingSuggestionSchema } from '../../../common';

export const CarePlan4SuggestionSchema = yup.object({
  consciousnessState: SuggestionSchema.nullable(),
  recognizeClosePersons: ScaleRatingSuggestionSchema.nullable(),
  localOrientation: ScaleRatingSuggestionSchema.nullable(),
  temporalOrientation: ScaleRatingSuggestionSchema.nullable(),
  situativeOrientation: ScaleRatingSuggestionSchema.nullable(),
  remember: ScaleRatingSuggestionSchema.nullable(),
  controlEverydayActions: ScaleRatingSuggestionSchema.nullable(),
  makeEverydayDecisions: ScaleRatingSuggestionSchema.nullable(),
  understandInformations: ScaleRatingSuggestionSchema.nullable(),
  recognizeRisks: ScaleRatingSuggestionSchema.nullable(),
  communicateNeeds: ScaleRatingSuggestionSchema.nullable(),
  understandRequest: ScaleRatingSuggestionSchema.nullable(),
  participateConversation: ScaleRatingSuggestionSchema.nullable(),
  eyeSight: ScaleRatingSuggestionSchema.nullable(),
  hearingAbility: ScaleRatingSuggestionSchema.nullable(),
  languageAbiltiy: ScaleRatingSuggestionSchema.nullable(),
  facialExpressions: ScaleRatingSuggestionSchema.nullable(),
  manageDailySchedule: ScaleRatingSuggestionSchema.nullable(),
  rest: ScaleRatingSuggestionSchema.nullable(),
  occupyOneself: ScaleRatingSuggestionSchema.nullable(),
  planFutureActivities: ScaleRatingSuggestionSchema.nullable(),
  interactWithPersons: ScaleRatingSuggestionSchema.nullable(),
  humanRelations: ScaleRatingSuggestionSchema.nullable(),
  stayOutdoor: ScaleRatingSuggestionSchema.nullable(),
  outdoorActivities: SuggestionSchema.nullable(),
  additionalMeasures: SuggestionSchema.nullable(),
});

export type ICarePlan4Suggestion = yup.InferType<typeof CarePlan4SuggestionSchema>;
